export var DINE_IN = 'dine-in';
//# sourceMappingURL=Dispatch.js.map